'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthorLink = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(AuthorLink, _React$PureComponent);

    function AuthorLink() {
        (0, _classCallCheck3.default)(this, AuthorLink);
        return (0, _possibleConstructorReturn3.default)(this, (AuthorLink.__proto__ || (0, _getPrototypeOf2.default)(AuthorLink)).apply(this, arguments));
    }

    (0, _createClass3.default)(AuthorLink, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                url = _props.url,
                noLink = _props.noLink;

            if (noLink) {
                return _react2.default.createElement(
                    'span',
                    null,
                    name
                );
            }
            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    'a',
                    { href: url },
                    name
                )
            );
        }
    }]);
    return AuthorLink;
}(_react2.default.PureComponent), _class.propTypes = {
    id: _propTypes2.default.number,
    name: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string,
    noLink: _propTypes2.default.bool
}, _temp);
exports.default = AuthorLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/AuthorLink.js
// module id = 441
// module chunks = 0